const labels = { temp: 'TEMP', saved: 'Saved', player: 'Registered', registered: 'Registered', captain: 'Captain', common: 'Common' };
const GaliPlayerBadge = ({ type, children }) => <span className={`gali-badge gali-badge-${type}`}>{children || labels[type] || type}</span>;
export default GaliPlayerBadge;
